define('home/models/SettingsApp',[
    'core/config',

    'home/models/common/BaseSettings',
], function (
    config,

    BaseSettings
) {
    'use strict';

    var SettingsApp = BaseSettings.extend({

        url: function () {
            return config.urls.apiSettings + 'apps/' + this.id + '/';
        },

        toJSON: function () {
            return {
                'id': this.get('id'),
                'name': this.get('name'),
            };
        },

    });

    return SettingsApp;
});


